export default function setUrl(url, secure = true) {
  const pattern = /^((http|https):\/\/)/;
  const prefix = secure ? 'https' : 'http';

  if (!pattern.test(url)) {
    return `${prefix}://${url}`;
  }

  return url;
}
